import { render, staticRenderFns } from "./AlphaCognize.vue?vue&type=template&id=2d62074a&scoped=true&"
import script from "./AlphaCognize.vue?vue&type=script&lang=js&"
export * from "./AlphaCognize.vue?vue&type=script&lang=js&"
import style0 from "./AlphaCognize.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AlphaCognize.vue?vue&type=style&index=1&id=2d62074a&scoped=true&lang=css&"
import style2 from "../../constant/css/detail.css?vue&type=style&index=2&id=2d62074a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62074a",
  null
  
)

export default component.exports